/*
 * The texts of the workflow extension, merged into the lib's own through its js/extension.ts.
 */
export default {
	sidebar: {
		workflows: 'Workflows',
	},
	pages: {
		workflows: {
			title: 'Workflows',
			info: 'A workflow is either a chain - forward, with ways out - or a free board. The catalogue holds the order, a variant leaves steps out. A step switched off stays visible as a gap.',
			none: 'This application has no configurable workflows.',
			required: 'Mandatory step',
			phase: 'Phase without a completion',
			field_visible: 'Asked for',
			field_required: 'Required',
			exits_hint: 'The ways out ({steps}) belong to every chain and cannot be switched off.',
			free_hint: 'A free workflow has no order: every state is reachable from every other.',
		},
	},
	workflow: {
		transition: {
			title: 'Next step',
			failed: 'Step not possible',
		},
		confirm: {
			title: 'Confirm step',
			text: 'Do you really want to set the record to "{step}"?',
		},
		history: {
			empty: 'No steps yet.',
			from: 'from "{step}"',
			system: 'System',
			undone: 'withdrawn',
		},
	},
};
